export default __webpack_public_path__ + "5796096038cbdb84972ac5b3735906b4.png";